module.exports = __webpack_public_path__ + "img/close.feb7e61b.svg";